var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eg-b-row',[_c('eg-b-col',[_c('eg-b-breadcrumb',{attrs:{"items":_vm.items}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }